module.exports = fox._r("images/promo/tutorial/14.jpg", __webpack_public_path__ + "_/common/images/promo/tutorial/14.jpg");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/14.jpg
// module id = 45
// module chunks = 2